'use client';

import { useContext } from 'react';
import { useFunnelSession } from '@/entities/session/model/funnel-session-context';
import { FunnelStepContext } from '.';

function useFunnelStepContext() {
  const ctx = useContext(FunnelStepContext);
  if (!ctx) {
    throw new Error('Funnel step context hooks must be used within FunnelStepProvider');
  }
  return ctx;
}

export function useFunnelFlattenedConfig() {
  return useFunnelStepContext().funnelFlattenedConfig;
}

export function useFunnelStepId() {
  return useFunnelStepContext().stepId;
}

export function useBranchId() {
  return useFunnelStepContext().branchId;
}

export function useFunnelConfigVersion() {
  return useFunnelStepContext().funnelConfigVersion;
}

export function useIsBranchFirstStep(): boolean {
  return useFunnelStepContext().isBranchFirstStep;
}

export function useIsBranchLastStep(): boolean {
  return useFunnelStepContext().isBranchLastStep;
}

export function useIsFirstStep(): boolean {
  return useFunnelStepContext().isFirstStep;
}

export function useIsFunnelSubmitting(): boolean {
  return useFunnelSession().isPending;
}

export function useStepProgress(): number {
  return useFunnelStepContext().progress;
}
